import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
    getSupportTicket,
    updateSupportStatus,
    replySupportTicket,
} from "../services/supportApi";

import TicketConversation from "../components/support/TicketConversation";
import ReplyBox from "../components/support/ReplyBox";

import "../css/Support.css";

function SupportDetails() {

    const { id } = useParams();

    const [ticket, setTicket] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadTicket = async () => {

        try {

            setLoading(true);

            const res = await getSupportTicket(id);

            setTicket(res.data.ticket);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadTicket();

    }, [id]);

    const handleStatusChange = async (status) => {

        try {

            await updateSupportStatus(id, { status });

            loadTicket();

        } catch (err) {

            console.error(err);

        }

    };

    const handleReply = async (formData) => {

        try {

            await replySupportTicket(id, formData);

            loadTicket();

        } catch (err) {

            console.error(err);

        }

    };

    if (loading) {

        return <h2>Loading...</h2>;

    }

    if (!ticket) {

        return <h2>Ticket not found.</h2>;

    }

    return (

        <div className="support-details-page">

            <div className="ticket-header">

                <div>

                    <h2>{ticket.ticketId}</h2>

                    <p>{ticket.subject}</p>

                </div>

                <div className="ticket-status">

                    <select
                        value={ticket.status}
                        onChange={(e) =>
                            handleStatusChange(e.target.value)
                        }
                    >

                        <option>Open</option>
                        <option>In Progress</option>
                        <option>Resolved</option>
                        <option>Closed</option>

                    </select>

                </div>

            </div>

            <div className="ticket-info">

                <div>

                    <strong>Customer</strong>

                    <p>{ticket.user?.name}</p>

                </div>

                <div>

                    <strong>Email</strong>

                    <p>{ticket.user?.email}</p>

                </div>

                <div>

                    <strong>Priority</strong>

                    <p>{ticket.priority}</p>

                </div>

                <div>

                    <strong>Category</strong>

                    <p>{ticket.category}</p>

                </div>

            </div>

            <TicketConversation ticket={ticket} />

            <ReplyBox onReply={handleReply} />

        </div>

    );

}

export default SupportDetails;